import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import { UserserviceService } from '../userservice.service';
import { ChartType } from 'angular-google-charts';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  loggeduser:any;
  roleid:any;
  apptype: any;
  allSubmittedRequest_title!: string;
  allSubmittedRequest_type!: any;
  allSubmittedRequest_options!:any;
  allSubmittedRequest_width!: any;
  allSubmittedRequest_height!: any;
  allSubmittedRequest_data!: any;
  allSubmittedRequestSSC_title!: string;
  allSubmittedRequestSSC_type!: any;
  allSubmittedRequestSSC_options!:any;
  allSubmittedRequestSSC_width!: any;
  allSubmittedRequestSSC_height!: any;
  allSubmittedRequestSSC_data!: any;
  migrationStatusCount_title!:any;
  migrationStatusCount_type!:any;
  migrationStatusCount_options!:any;
  migrationStatusCount_width!:any;
  migrationStatusCount_height!:any;
  migrationStatusCount_data!:any;
  allSubmittedRequests: any;
  noHSSCData:boolean=false;
  noSSCData:boolean=false;
  // isstudent:boolean=false;
  // isboardadmin:boolean=false;
  constructor(private service:UserserviceService ,public router: Router,private route: ActivatedRoute,) { }

  ngOnInit(): void {
    this.loggeduser= sessionStorage.getItem('loggeduser');
    this.roleid= sessionStorage.getItem('roleid');
    this.apptype=sessionStorage.getItem('loggedapptype');
    // console.log(this.loggeduser);
    if(this.loggeduser=="" || this.loggeduser==null){
      this.router.navigate(['/Login']);
    }
    if(this.roleid==2|| this.roleid==3){

      this.getdashboardDataforBoardadmin()
    }
  }
  get isstudent(){
    return this.loggeduser && this.roleid === "1";
  }
  get isboardadmin(){
    return this.loggeduser && this.roleid === "2";
  }
  get isboardcord(){
    return this.loggeduser && this.roleid === "3";
  }
  get isfreshmigration(){
    return this.isstudent && this.apptype === "Fresh_Migration_Certificate";
  }
  get isnamechagemarsheet(){
    return this.isstudent && this.apptype === "Change_Request_On_Marksheet";
  }
  get isnamechagepassingcert(){
    return this.isstudent && this.apptype === "Change_Request_On_Passing_Certificate";
  }
  get isduplimigration(){
    return this.isstudent && this.apptype === "Duplicate_Migration_Certificat";
  }
  get isduplicatepassingcertificate(){
    return this.isstudent && this.apptype === "Duplicate_Passing_Certificate";
  }
  get isduplicatemarsheet(){
    return this.isstudent && this.apptype === "Duplicate_Marksheet";
  }

  getdashboardDataforBoardadmin() {
      this.service.post('/Boardadmin_module/getBoardDashboardData',{}).subscribe((res:any)=>{
        if(res.status=="success"){
            this.allSubmittedRequests=res.Data;
            // this.allSubmittedRequest_title = 'Total Request Submitted HSSC: '+this.allSubmittedRequests.total;              
            // this.allSubmittedRequestSSC_title = 'Total Request Submitted SSC: '+this.allSubmittedRequests.SSCtotal;
            this.allSubmittedRequest_title = 'Total Pending Requests HSSC: '+this.allSubmittedRequests.total;              
            this.allSubmittedRequestSSC_title = 'Total Pending Requests SSC: '+this.allSubmittedRequests.SSCtotal;
            if(this.allSubmittedRequests.total==0){
              this.noHSSCData=true;
            }
            else{
              this.noHSSCData=false;
              this.allSubmittedRequest_data = [
                ['Fresh Migration Certificate',this.allSubmittedRequests.fresh_migration],
                ['Duplicate Passing Certificate',this.allSubmittedRequests.duplicate_passing_certificate],
                ['Duplicate Migration Certificate',this.allSubmittedRequests.duplicate_migration],
                ['Duplicate Marksheet',this.allSubmittedRequests.duplicate_marksheet],
                ['Change Request On Marksheet',this.allSubmittedRequests.chg_marksheet],
                ['Change Request On Passing Certificate',this.allSubmittedRequests.chg_passing_certificate]
              ];
             
            }
            if(this.allSubmittedRequests.SSCtotal==0){ 
              this.noSSCData=true;
            }
            else{
              this.noSSCData=false;
                this.allSubmittedRequestSSC_data = [
                  ['Fresh Migration Certificate',this.allSubmittedRequests.SSCfresh_migration],
                  ['Duplicate Passing Certificate',this.allSubmittedRequests.SSCduplicate_passing_certificate],
                  ['Duplicate Migration Certificate',this.allSubmittedRequests.SSCduplicate_migration],
                  ['Duplicate Marksheet',this.allSubmittedRequests.SSCduplicate_marksheet],
                  ['Change Request On Marksheet',this.allSubmittedRequests.SSCchg_marksheet],
                  ['Change Request On Passing Certificate',this.allSubmittedRequests.SSCchg_passing_certificate]
                ];
               
            }
           
           
           
            
		    }
        else{
         
        }
          
      });
   
       //all request submitted HSSC start
       this.allSubmittedRequest_type = ChartType.PieChart;       
       this.allSubmittedRequest_options = { 
        //  colors: ['#edbf74','#6eaf99','#e68b86','#9daadf'], 
         colors: ['#17bebb','#ff815e','#fdc656','#ff6666','#d1b9ac','#9cb947'], 
         is3D: true,
        //  legend: {position: 'right',alignment:'left', textStyle: {color: 'black', fontSize: 14}},
        legend:'none',
         pieSliceText:'value',
       };
       this.allSubmittedRequest_width = 310;
       this.allSubmittedRequest_height = 240;
     //all request submitted HSSC end
       //all request submitted SSC start
       this.allSubmittedRequestSSC_type = ChartType.PieChart;       
       this.allSubmittedRequestSSC_options = { 
         colors: ['#8D9B6A','#d1742e','#8A9EA7','#DAB692','#913ccd','#cddc39'], 
         is3D: true,
        //  legend: {position: 'right',alignment:'left', textStyle: {color: 'black', fontSize: 14}},
        legend:'none',
         pieSliceText:'value',
       };
       this.allSubmittedRequestSSC_width = 310;
       this.allSubmittedRequestSSC_height = 240;
     //all request submitted SSC end



    //Status Migration request status start
      this.migrationStatusCount_title = 'Migration Request Status';
      this.migrationStatusCount_type = ChartType.PieChart;
      this.migrationStatusCount_options = { 
        colors: ['#edbf74','#6eaf99','#e68b86','#9daadf'],//['#b1d3c5','#cddb8c','#e5beb4','#e2f1e7'], //'#f15f74', '#913ccd','#2ca8c2'
        is3D: true,
        legend: {position: 'right',alignment:'left', textStyle: {color: 'black', fontSize: 14}},
        pieSliceText:'value',
      };
      this.migrationStatusCount_width = 600;
      this.migrationStatusCount_height = 240;
      this.migrationStatusCount_data = [
          ['Pending', 400],
          ['Rejected', 1200],
          ['Cancelled', 600]
        ];
    //Status Migration request status end
  }
}
